import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const departamentosAdapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `book.id`
  selectId: x => x.departamentoId,

  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => a.title.localeCompare(b.title),
})

const initialState = departamentosAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getDepartamentos: builder.query({
      query: () => 'departamentos',
      transformResponse: responseData => {
        return departamentosAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg) => [
        { type: 'Departamentos', id: 'LIST' }
      ]
    }),
    clasesContratos: builder.query({
      query: ()=> 'clasesContrato',
      providesTags: (result, error, arg)=>[
        {type:'ClasesContratos', id: 'LIST'}
      ]
    }),
    addDepartamento: builder.mutation({
      query: (newDepartamento)=>({
        url: 'departamentos',
        method: 'post',
        body: newDepartamento
      }),
      invalidatesTags: ["Departamentos"]
    }),
    editDepartamento: builder.mutation({
      query: (departamentoUpdated)=>({
        url: 'departamentos',
        method: 'put',
        body: departamentoUpdated
      }),
      invalidatesTags: ["Departamentos"]
    }),
    deleteDepartamentos: builder.mutation({
      query: (idsDepartamentosToDelete)=>({
        url: 'departamentos',
        method: 'delete',
        body: idsDepartamentosToDelete
      }),
      invalidatesTags: ["Departamentos"]
    }),
  })
});

export const { useGetDepartamentosQuery, useAddDepartamentoMutation, useEditDepartamentoMutation, useClasesContratosQuery,useDeleteDepartamentosMutation } = extendedApiSlice;

//A: returns the query result object
export const selectDepartamentosResult = extendedApiSlice.endpoints.getDepartamentos.select();

//A: created memoized selector
const selectDepartamentosData = createSelector(
  selectDepartamentosResult,
  departamentosResult => departamentosResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllDepartamentos,
  selectById: selectDepartamentoById,
  selectIds: selectDepartamentoIds
} = departamentosAdapter.getSelectors(state => selectDepartamentosData(state) ?? initialState);